import { Link } from "react-router-dom";

const sections = [
  { title: "Company", links: [
    { label: "About", to: "/about" },
    { label: "Careers", to: "/careers" },
    { label: "Press", to: "/press" },
  ]},
  { title: "Watch", links: [
    { label: "Movies", to: "/movies" },
    { label: "TV Shows", to: "/series" },
    { label: "Live TV", to: "/live" },
    { label: "Kids", to: "/kids" },
  ]},
  { title: "Support", links: [
    { label: "Help Center", to: "/help" },
    { label: "Contact", to: "/contact" },
    { label: "Devices", to: "/devices" },
  ]},
  { title: "Legal", links: [
    { label: "Terms", to: "/terms" },
    { label: "Privacy", to: "/privacy" },
    { label: "Cookies", to: "/cookies" },
  ]},
];

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-20 py-12 px-6 sm:px-12 bg-[#0a0a0a]" data-testid="footer">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mb-8">
          {sections.map((s) => (
            <div key={s.title}>
              <h4 className="text-sm font-bold text-white mb-3" style={{ fontFamily: "Outfit" }}>{s.title}</h4>
              <ul className="space-y-2 text-sm text-[#999]">
                {s.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="hover:text-white transition" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-md bg-[#E50914] flex items-center justify-center font-black text-white" style={{ fontFamily: "Outfit" }}>D</div>
            <span className="text-sm font-bold text-white" style={{ fontFamily: "Outfit" }}>Djino<span className="text-[#E50914]">Stream</span></span>
          </Link>
          <div className="text-xs text-[#666]">© 2026 Djino Stream. All rights reserved. Original premium streaming for everyone.</div>
        </div>
      </div>
    </footer>
  );
}
